import { render, staticRenderFns } from "./FormCheckboxColor.vue?vue&type=template&id=4cd8eeb6"
import script from "./FormCheckboxColor.vue?vue&type=script&lang=js"
export * from "./FormCheckboxColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports